import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/ui-kit";
import { Loader, EmptyState } from "@/components/Loader";
import { UserPlus, MapPin, HeartHandshake, Siren, UserCheck, Clock, Activity as ActIcon } from "lucide-react";

const ICONS = {
  account: UserCheck, community: MapPin, trusted_contact: UserPlus,
  care: HeartHandshake, wellness_check: HeartHandshake, onboarding: UserCheck, emergency: Siren,
};

const fmt = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
};

export default function ActivityPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/activities").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <Loader />;

  return (
    <div className="ll-fade-up" data-testid="activity-screen">
      <PageHeader title="Activity" subtitle="A timeline of your important actions." />
      <div className="px-5">
        {items.length === 0 ? (
          <EmptyState icon={ActIcon} title="No activity yet" subtitle="Your important actions will appear here." />
        ) : (
          <div className="relative pl-4">
            <div className="absolute left-[26px] top-2 bottom-2 w-0.5 bg-[#C4B5FD]/50" />
            <div className="space-y-4">
              {items.map((a) => {
                const Icon = ICONS[a.type] || Clock;
                return (
                  <div key={a.id} className="flex gap-4 items-start relative" data-testid={`activity-${a.id}`}>
                    <div className="w-9 h-9 rounded-full bg-white border-2 border-[#C4B5FD] flex items-center justify-center shrink-0 z-10"><Icon className="w-4 h-4 text-[#F97316]" /></div>
                    <div className="bg-white rounded-2xl p-4 flex-1 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-[#111827]/5">
                      <p className="font-bold">{a.title}</p>
                      {a.description && <p className="text-sm text-[#111827]/60 mt-0.5">{a.description}</p>}
                      <p className="text-xs text-[#111827]/40 mt-2 flex items-center gap-1"><Clock className="w-3 h-3" /> {fmt(a.created_at)}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
